export const ANTI_FORGERY_FIELD_NAME = "__RequestVerificationToken";
export const XSRF_COOKIE_NAME = "XSRF-TOKEN";
export const XSRF_HEADER_NAME = "X-XSRF-TOKEN";
export const HTTP_HEADERS = {
    json: { Accept: "application/json" },
    jsonContent: { Accept: "application/json", "Content-Type": "application/json" },
    html: { Accept: "text/html" }
};
export const VALIDATION_ERROR_SELECTOR = ".validation-summary-errors, .field-validation-error";
export const REQUEST_CREDENTIALS = "same-origin";
